export function isSafariBrowser() {
  if (typeof navigator === 'undefined') {
    return false;
  }

  const ua = navigator.userAgent;
  const vendor = navigator.vendor;

  return (
    /Safari/i.test(ua) &&
    /Apple Computer/i.test(vendor) &&
    !/CriOS|Chrome|FxiOS|EdgiOS|OPiOS|OPR/i.test(ua)
  );
}
